import { createSelector } from "reselect";
const selectRealisationsState = createSelector((state) => state.realisations, realisations => realisations);
const selectRealisations = createSelector(selectRealisationsState, state => state.list);
export { selectRealisations };
